import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocationInfoService {
  Receive_info: Subject<any> = new Subject();
  callback_info: Subject<any> = new Subject();
  constructor() { }
  
  Show(data){
   this.Receive_info.next({  data:data});
  }
  Callback(data){
    this.callback_info.next({ data:data});
  }
  close(data){
    this.Receive_info.next(data);
   }
}
